"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeEventPayloadHandler = makeEventPayloadHandler;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Constants = require("FileManagerLib/Constants");

function makeEventPayloadHandler(usageTracker) {
  return function (action) {
    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!usageTracker.trackInteraction) {
      return (0, _extends2.default)({
        action: action
      }, meta);
    }

    var appName = usageTracker.app || 'unknown';
    return {
      where_app_override: 'file-picker',
      where_screen: 'picker',
      what_extra_json: (0, _extends2.default)({}, _Constants.DEFAULT_TRACKING_META, {
        action: action
      }, meta, {
        'in-app': appName
      })
    };
  };
}